"use client";

import { cn } from "@/ts/util/cn";
import styles from "./ShareButton.module.scss";
import { PopupButton } from "@/app_components/generic/popup/PopupButton";
import React, { useEffect, useState } from "react";
import { ShareIcon } from "@/app_components/icon/ShareIcon";
import { LinkIcon } from "@/app_components/icon/LinkIcon";
import { useCopy } from "@/app_util/useCopy";
import CheckIcon from "@/app_components/icon/CheckIcon";


interface ShareButtonProps {
    className?: string;
}


export function ShareButton({
    className = "text-md",
}: ShareButtonProps) {

    const [url, setURL] = useState<string | null>(null);
    const { copyText, doCopy, copyState, setCopyState } = useCopy(
        url, "Copy Link", "Copied Link",
    );

    useEffect(() => {
        setURL(new URL(window.location.pathname, window.location.href).href);
    }, [setURL]);

    return (
        <PopupButton
            buttonClassName={cn(className, styles.button)}
            contentClassName={styles.menu}
            darkMode={true}
            minPopupWidthPx={240}
            buttonContent={(
                <>
                    <ShareIcon className={styles.share_icon} />
                    <span>Share</span>
                </>
            )}
            onClose={() => {
                setCopyState("copy");
            }}>

            <button
                className={cn(
                    copyState === "copied" && styles.copied,
                )}
                onClick={doCopy}>
                <LinkIcon />
                <span>
                    {copyText}
                </span>
                {copyState === "copied" && (
                    <CheckIcon className="margin-left-2xs" />
                )}
            </button>
        </PopupButton>
    );
}
